import { Link } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import PakLogo from "@/components/PakLogo";

// Giriş/Kayıt ekranlarının üst kısmı.
// - Native uygulama: bar yok, yalnızca ortada logo.
// - Web: eski görünüm (logo solda, "← Ana Sayfa" sağda).
export default function AuthHeader() {
  if (Capacitor.isNativePlatform()) {
    return (
      <header className="bg-white">
        <div className="max-w-7xl mx-auto px-5 h-16 flex items-center justify-center">
          <PakLogo />
        </div>
      </header>
    );
  }
  return (
    <header className="bg-white border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between">
        <PakLogo />
        <Link to="/" className="text-sm text-slate-500 hover:text-[#10B981]">
          ← Ana Sayfa
        </Link>
      </div>
    </header>
  );
}
